import { pickThemeFontStyles } from '@/theme';
import { Button } from '@/ui';
import styled from 'styled-components';

export const StyledMessage = styled.p`
  ${pickThemeFontStyles('14', '20')}

  &:not(:last-of-type) {
    margin: 0;
  }
`;

export const StyledButton = styled(Button)`
  && {
    margin-inline-start: auto;
    display: flex;
  }
`;
